// extracted by mini-css-extract-plugin
module.exports = {"avatar":"BrandOption__avatar___1JS0H","name":"BrandOption__name___KOFwB"};